{
	"accept_invite": {
		"description": "Imposta una password per completare l'attivazione del tuo account.",
		"invalid_link_description": "Contatta il tuo amministratore per richiedere un nuovo invito.",
		"invalid_link_title": "Link di invito non valido",
		"submit": "Attiva account",
		"success": "Account attivato, accedi con la tua nuova password.",
		"title": "Attiva il tuo account"
	},
	"back_to_login": "Torna all'accesso",
	"confirm_password": "Conferma password",
	"cooldown": "Reinvia tra {{seconds}}s",
	"email_placeholder": "Inserisci il tuo indirizzo email",
	"forgot_password": {
		"description": "Inserisci l'indirizzo email del tuo account e ti invieremo un link per reimpostare la password.",
		"email_sent_description": "Controlla la tua email e segui le istruzioni per reimpostare la password.",
		"email_sent_title": "Email inviata",
		"resend": "Invia di nuovo",
		"submit": "Invia link di reimpostazione",
		"title": "Password dimenticata?"
	},
	"log_in": "Accedi",
	"login": {
		"forgot_password": "Password dimenticata?"
	},
	"reset_password": {
		"description": "Scegli una password sicura per proteggere il tuo account",
		"invalid_token": "Questo link di reimpostazione password non è valido o è scaduto.",
		"request_another": "Serve un nuovo link? <requestLink>Richiedi un'altra email di reimpostazione</requestLink>",
		"request_new_link": "Richiedi un nuovo link di reimpostazione",
		"submit": "Reimposta password",
		"title": "Imposta una nuova password"
	},
	"validation": {
		"email_invalid": "Inserisci un indirizzo email valido.",
		"password_invalid": "Inserisci una password valida.",
		"passwords_mismatch": "Le password non corrispondono."
	}
}
